const FetchInitialState = {
  status: "",
  error: false,
  message: "",
  successMsg: "",
};

export default FetchInitialState;
